<template>
  <div>
    <!-- The title -->
    <div class="majorTitle">
      Shipping & Pick-up
    </div>
    <div class="minorTitle">
      How will you be receiving your items?
    </div>

    <!-- The message -->
    <div
      v-if="customerArrangeItems.length > 0"
      class="accountMenuFullHeightContainer"
    >
      <div class="marginNoneBottom">
        <p>
          Thank you for your payment, and congratulations on your winning bids.  Please review the options listed below, and let us know how you would like to receive your items.
        </p>
      </div>

      <!-- The items -->
      <ul class="marginLargeBottom">
        <li
          v-for="item in customerArrangeItems"
          :key="item.inventory_id"
          class="itemRow"
        >
          <a class="colorBlack u-full-width">
            <div class="dropdownLeadImageContainer">
              <img
                v-if="item.lead_image !== null"
                :src="item.lead_image"
                alt="item.lead"
              >
            </div>
            <div>
              <span>
                Lot {{ item.display_lotnumber }} &middot; {{ item.lead }}
              </span>
            </div>
          </a>
        </li>
      </ul>

      <!-- The fullfillment options -->
      <div class="marginMarginBottom">
        <div class="row">
          <div class="one columns">
            <input
              id="quote"
              v-model="shippingChoice"
              class="hiddenInput"
              name="fullfillment_type"
              value="Shipping Details"
              type="radio"
            >
            <label
              for="quote"
              class="radioCheckboxOutline"
            >
              <div class="radioCheckbox">
                <div class="radioCheck" />
              </div>
            </label>
          </div>
          <div class="eleven columns">
            <div class="fontBold paddingSmallBottom">
              Let us ship it to you.
            </div>
            <p> 
              Our in-house shipping department will create a customized shipping quote for your approval.  Once approved, we will professionally package your items, ship them to you, and provide tracking information.
            </p>
          </div>
        </div>
        <div class="row marginNormalBottom">
          <div class="one columns">
            <input
              id="pickup"
              v-model="shippingChoice"
              class="hiddenInput"
              name="fullfillment_type"
              value="Pick up Details"
              type="radio"
            >
            <label
              for="pickup"
              class="radioCheckboxOutline"
            >
              <div class="radioCheckbox">
                <div class="radioCheck" />
              </div>
            </label>
          </div>
          <div class="eleven columns">
            <div class="fontBold paddingSmallBottom">
              I will arrange pick up.
            </div>
            <p> 
              Select this option if you would like to pick up your items personally, or have someone else pick them up for you.  This includes appointing a third-party vendor when coordinating your own shipping.
            </p>
          </div>
        </div>
      </div>

      <!-- The continue button -->
      <button
        v-if="shippingChoice === ''"
        class="bidButton disabledButton"
      >
        Continue
      </button>
      <button
        v-else
        class="bidButton backgroundColorDefault"
        @click.prevent="submitShippingChoice"
      >
        Continue
      </button>
    </div>

    <div v-else>
      There are no items that require shipping or pick-up arrangements.
    </div>
  </div>
</template>

<script>

export default {

	name: 'ArrangeFullfillment',

	data () {
		return {
			'shippingChoice': ''
		}
	},

	computed: {
		customerArrangeItems: function () {
			let items = []
			let self = this
			Object.values(this.$store.getters.requestQuoteInventoryIds).forEach(function (value) {
				items.push(self.$store.getters.item(value))
			})
			return items
		}
	},
	methods: {
		insertAccountMenu (payload) {
			this.$store.dispatch('insertAccountHistory', payload)
		},
		submitShippingChoice: function () {
			this.insertAccountMenu(this.shippingChoice)
		}
	}
}

</script>

<style scoped>

</style>
